import { MotifButton, MotifCheckbox, MotifIcon, MotifTable, MotifTableHeaderRenderer, MotifTooltip } from
    '@ey-xd/motif-react'
import React, { useEffect } from 'react'
import ViewQuestionsTableRow from './ViewQuestionsTableRow'
import iconSvg from "../../assets/icons/icon.svg.json";

const ViewQuestionsTable = (props: any) => {
    const { content, getAiRecommendation, setEnabledOptions } = props;
    const [enabledRecommendedOptions, setEnabledRecommendedOptions] = React.useState(["Top_1", "Top_2", "Top_3"]);
    const [genericOutputEnabled, setGenericOutputEnabled] = React.useState(false);

    const { table } = content;

    const tableArray = Object.keys(table).map(key => table[key]);
    const numRows = Object.keys(tableArray?.[0])?.length ?? 0;
    const togleRecommendedOption = (option: string) => {
        if (enabledRecommendedOptions.includes(option)) {
            if (enabledRecommendedOptions.length === 1) return;
            setEnabledRecommendedOptions(enabledRecommendedOptions.filter((item) => item !== option));
        } else {
            setEnabledRecommendedOptions([...enabledRecommendedOptions, option]);
        }
    }
    useEffect(() => {
        setEnabledOptions(enabledRecommendedOptions);
    }, [enabledRecommendedOptions])


    const rows: string[][] = [];
    for (let i = 0; i < numRows; i++) {
        const row: string[] = [];
        for (const column of tableArray) {
            row.push(column[i]);
        }
        rows.push(row);
    }
    return (
        <div className="w-full">
            <table className="w-full text-left ">
                <thead className="bg-[#1A1A24] table-header !sticky top-[-1px]" style={{ zIndex: 1 }}>
                    <tr>
                        <th className="border p-4 border-[#A4A3B1]">Questions</th>
                        <th className="border p-4 border-[#A4A3B1]">
                            <div className="flex gap-3 items-center">
                                <div>
                                    Options:
                                </div>
                                <div className="flex gap-2">
                                    <span className={`!font-light px-3 cursor-pointer border border-[#A4A3B1] rounded-md ${enabledRecommendedOptions.includes("Top_1") && "bg-[#A4A3B1]"}`} onClick={() => togleRecommendedOption("Top_1")}>Top 1</span>
                                    <span className={`!font-light px-3 cursor-pointer border border-[#A4A3B1] rounded-md ${enabledRecommendedOptions.includes("Top_2") && "bg-[#A4A3B1]"}`} onClick={() => togleRecommendedOption("Top_2")}>Top 2</span>
                                    <span className={`!font-light px-3 cursor-pointer border border-[#A4A3B1] rounded-md ${enabledRecommendedOptions.includes("Top_3") && "bg-[#A4A3B1]"}`} onClick={() => togleRecommendedOption("Top_3")}>Top 3</span>
                                </div>
                            </div>
                        </th>
                        <th className="border p-4 border-[#A4A3B1]">
                            <div className="flex gap-2 items-center">
                                <div>Output:</div>
                                <div className='flex gap-1 px-1.5'>
                                    <MotifButton
                                        onClick={() => setGenericOutputEnabled(false)}
                                        variant={!genericOutputEnabled ? "primary-alt": "secondary"}
                                        type="button"
                                    >
                                        AI Recommended
                                    </MotifButton>
                                    <MotifButton
                                        variant={genericOutputEnabled ? "primary-alt": "secondary"}
                                        onClick={() => setGenericOutputEnabled(true)}
                                        type="button"
                                    >
                                        AI Generic
                                    </MotifButton>
                                </div>
                            </div>
                        </th>
                        <th className="border p-4 border-[#A4A3B1]">Customize</th>

                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {                 
                        const rowSingle = {
                            Top_1: {
                                text: table?.["Top_1"]?.[index],
                                score: table?.["Score_1"]?.[index]
                            },
                            Top_2: {
                                text: table?.["Top_2"]?.[index],
                                score: table?.["Score_2"]?.[index]
                            },
                            Top_3: {
                                text: table?.["Top_3"]?.[index],
                                score: table?.["Score_3"]?.[index]
                            },
                            Requirement: table?.["Requirement"]?.[index],
                            "AI_Recommendations": (table?.[genericOutputEnabled ? "AI Generic Recommendation" : "AI Recommendations"] ?? [])?.[index],
                            "Customized": table?.["Customized Response"] && table?.["Customized Response"]?.[index],
                        }
                        return (
                            <ViewQuestionsTableRow enabledRecommendedOptions={enabledRecommendedOptions} key={index} row={rowSingle} getAiRecommendation={(selectedOptions) => getAiRecommendation(selectedOptions, index)} />
                        )
                    }
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default ViewQuestionsTable